import { mapToClientSurveyProps } from './survey.server';

export const mapToClientJobProps = (serverJob, lineId) => {
	const jobId = serverJob.job;
	const strJobId = serverJob.str_job;
	return {
		lineId,
		id: jobId,
		strid: strJobId,
		scanlineEnabled: serverJob.scanline,
		entity: serverJob.entity,
		corrosionTechnician: serverJob.ct,
		projectManager: serverJob.pm,
		surveys: (serverJob.surveys || []).map(survey =>
			mapToClientSurveyProps(survey, lineId, jobId, strJobId)
		)
	};
};

export default { mapToClientJobProps };
